import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

export const TAGS_BASE_KEY = 'tags';

export const tagsApiQueryKeys = {
  all: () => [TAGS_BASE_KEY] as const,
  forTarget: (targetType: TaggableType, targetId: string) =>
    [TAGS_BASE_KEY, 'target', targetType, targetId] as const,
};
